import CheckIcon from '@mui/icons-material/Check';
import { Grid, Avatar, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { theme, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

type LayOutProps = {
  message: string;
  button?: ReactElement;
  icon?: ReactElement;
  isHtml?: boolean;
  bold?: boolean;
};
const SuccessMessageLayout = ({
  message,
  button,
  icon = (
    <Avatar sx={{ backgroundColor: theme.palette.primary.light, m: 'auto' }}>
      <CheckIcon />
    </Avatar>
  ),
  isHtml = false,
  bold = false,
}: LayOutProps) => {
  return (
    <Grid container spacing={3} display="flex" direction="row" height="100%" m={'auto'}>
      <Grid item xs={12} display="flex">
        {icon}
      </Grid>
      <Grid item xs={12} textAlign="center">
        {!isHtml ? (
          <WsTypography
            color={WsTypoColors.SECONDARY}
            bold={bold}
            variant={WsTypoVariants.SUB_TITLE}
          >
            {message}
          </WsTypography>
        ) : (
          <Typography dangerouslySetInnerHTML={{ __html: message }}></Typography>
        )}
      </Grid>
      {button && (
        <Grid item xs={12} textAlign="center">
          {button}
        </Grid>
      )}
    </Grid>
  );
};
export default SuccessMessageLayout;
